import { render, staticRenderFns } from "./car_info.vue?vue&type=template&id=41136b67&scoped=true&"
import script from "./car_info.vue?vue&type=script&lang=js&"
export * from "./car_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41136b67",
  null
  
)

export default component.exports